// extracted by mini-css-extract-plugin
export var about = "home-about-module--about--fa937";
export var about__btn = "home-about-module--about__btn--e8a0d";
export var about__descript = "home-about-module--about__descript--f0b74";
export var about__img = "home-about-module--about__img--c5aec";
export var about__text = "home-about-module--about__text--3ac6e";
export var about__title = "home-about-module--about__title--c55a7";
export var about__wrapp = "home-about-module--about__wrapp--c7921";
export var menu__cardsButton = "home-about-module--menu__cardsButton--ed343";